import React, { useEffect, useState } from "react";
import helperFunction from "../../Function/helperFunction";

const initialValues = {
  non_fragile: {
    value: "",
    premium_per: "",
    premium: 0,
  },
  fragile: {
    value: "",
    premium_per: "",
    premium: 0,
  },
  total_goods_value: 0,
  total_premium: 0,
};

export const InsuranceCalculator = () => {
  const [data, setData] = useState(JSON.parse(JSON.stringify(initialValues)));

  const handleReset = () => {
    setData(initialValues);
  };

  const calculate = (e, outerKey) => {
    const { name, value } = e.target;

    let dataCopy = { ...data };

    const val = value ? Number(value) : value

    if(outerKey){
      dataCopy[outerKey][name] = val;
    }else{
      dataCopy[name] = val;
    }

    const non_fragile_premium = (dataCopy.non_fragile.premium_per * dataCopy.non_fragile.value) / 100
    dataCopy.non_fragile.premium = Number(helperFunction.handleDecimalPoints(non_fragile_premium,2,true));

    const fragile_premium = (dataCopy.fragile.premium_per * dataCopy.fragile.value) / 100
    dataCopy.fragile.premium = Number(helperFunction.handleDecimalPoints(fragile_premium,2,true));

    dataCopy.total_goods_value = dataCopy.non_fragile.value + dataCopy.fragile.value;

    const total_premium = Number(dataCopy.non_fragile.premium + dataCopy.fragile.premium);
    
    dataCopy.total_premium = (dataCopy.non_fragile?.premium || dataCopy.fragile?.premium)
    ? total_premium>175
    ? total_premium 
    : 175
    : 0
    
    setData(dataCopy)
  };


  return (
    <div className="w-75">
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center"></th>
                  <th className="text-center">Total Non Fragile Goods Value</th>
                  <th className="text-center">Total Fragile Goods Value</th>
                  <th className="text-center">Total Goods Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold">Value</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Non Fragile Value"
                      name="value"
                      value={data.non_fragile.value}
                      onChange={(e) => calculate(e, "non_fragile")}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Fragile Value"
                      value={data.fragile.value}
                      name="value"
                      onChange={(e) => calculate(e, "fragile")}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={data.total_goods_value}
                      readOnly
                    />
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold">Premium %</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Premium %"
                      value={data.non_fragile.premium_per}
                      name="premium_per"
                      onChange={(e) => calculate(e, "non_fragile")}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Premium %"
                      value={data.fragile.premium_per}
                      name="premium_per"
                      onChange={(e) => calculate(e, "fragile")}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold">Premium</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={data.non_fragile.premium}
                      readOnly
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={data.fragile.premium}
                      readOnly
                    />
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold">Total Premium</td>
                  <td colSpan={2}> 
                    {data.total_premium && 
                      <p className="fw-bold mb-0 fs-6 ms-2">{`${data.total_premium}/-`}</p>
                    }
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="d-flex">
              <button
                className="btn btn-danger mt-3 me-2"
                onClick={() => handleReset()}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceCalculator;
